import React, { memo, useCallback, useMemo } from 'react';

import { FilterBaseCDS, FilterTypes } from '@sharedCR/coreDesignSystem/Table';
import _ from 'lodash';
import PropTypes from 'prop-types';

import useFilter from 'hooks/useFilter';

import { ProgramsAndPricingTestIds } from '../../../ProgramsAndPricing.testIds';

const defaultOptions = [];

const ProgramFilterSelect = ({
  filtersGroupId,
  filterId,
  selectOptions = defaultOptions,
  filterType = FilterTypes.MULTI_SELECT,
  defaultValue,
  label = '',
  ...otherProps
}) => {
  const { filterValues, setFilterValue } = useFilter({ filtersGroupId, filterId, defaultValue });

  const filterKey = useMemo(
    () => (_.isArray(filterValues) ? filterValues.join(',') : String(filterValues ?? '')),
    [filterValues],
  );

  const getDataTestIdOption = useCallback(
    value => ProgramsAndPricingTestIds.getFilterOptionId(filterId, value),
    [filterId],
  );

  return (
    <FilterBaseCDS
      dataTestId={ProgramsAndPricingTestIds.getFilterId(filterId)}
      filterType={filterType}
      filterValues={filterValues}
      getDataTestIdOption={getDataTestIdOption}
      key={filterKey}
      label={label}
      selectOptions={selectOptions}
      setFilterValue={setFilterValue}
      {...otherProps}
    />
  );
};

ProgramFilterSelect.propTypes = {
  filtersGroupId: PropTypes.string.isRequired,
  filterId: PropTypes.string.isRequired,
  selectOptions: PropTypes.array,
  filterType: PropTypes.string,
  defaultValue: PropTypes.array,
  label: PropTypes.string,
  width: PropTypes.number,
};

export default memo(ProgramFilterSelect);
